import { ArrowRight, Coffee, Slack } from "lucide-react";
import { focusRing } from "../ui/focusRing";

interface HeroSectionProps {
  slackOauthUrl: string;
}

export function HeroSection({ slackOauthUrl }: HeroSectionProps) {
  return (
    <section className="pt-32 pb-20 px-6 bg-white">
      <div className="max-w-5xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-50 border border-orange-200 text-stone-800 text-sm font-medium mb-8 shadow-sm">
          <Coffee className="w-4 h-4 text-brand-orange" />
          Queue management for Slack
        </div>
        <h1 className="text-4xl md:text-6xl font-bold text-stone-800 mb-6 leading-tight">
          Queue it.
          <br />
          <span className="text-brand-orange">Own it. Close it.</span>
        </h1>
        <p className="text-xl text-stone-600 max-w-2xl mx-auto mb-10 leading-relaxed">
          Kyubot turns Slack messages into trackable items. Capture requests with emoji, assign an
          owner, mark done, and notify the requester.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href={slackOauthUrl}
            className={`group flex items-center gap-2 bg-brand-orange text-white px-8 py-4 rounded-full font-semibold text-xl hover:bg-brand-orange-hover transition-all shadow-lg shadow-brand-orange/20 hover:shadow-xl hover:shadow-brand-orange/30 ${focusRing}`}
          >
            <Slack className="w-5 h-5" />
            Add to Slack
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
        <p className="text-sm text-stone-600 mt-4">Free plan available • Setup in under a minute</p>
      </div>
    </section>
  );
}
